$(function () {
	$(".js-table-more").on("click", function () {
		$(this).hide();
		var targetTable = $(this).prev(".js-table-hide");
		targetTable.find(".js-target").show();
		return false;
	});

	var $width = $(window).width();
	function postContentsWidth() {
		var $c = $(".js-sp-w");
		$c.each(function () {
			var $t = $(this).find(".js-sp-w-tgt");
			var $tl = $t.length;
			var $tw = $t.width();

			if (typeof $(this).data("space") !== "undefined") {
				var $cs = $(this).data("space");
				var $ct = ($tl - 1) * $cs;
			} else {
				var $ct = 0;
			}

			var $cw = $tl * $tw + $ct;
			// console.log($tl, $tw, $ct);
			$(this).css("width", $cw);
		});
	}

	function postScrollTable() {
		var $t = $(".js-tbl");
		var $tw = $t.width();

		$t.each(function () {
			var $hd = $(this).find(".js-tbl-hd");
			var $hdw = 90;
			var $td = $(this).find("td");
			var $tdl = $t.find("tbody tr:first-of-type td").length;
			var $v = $tw - $hdw - 20;
			// console.log($tw, $hdw, $v, $tdl);
			$(this).find("tbody tr").css("display", "flex");
			$hd.css("width", $hdw);
			$hd.css("flex-shrink", 0);
			$td.css("width", $v);
			$t.css("width", $hdw + $v * $tdl);
		});
	}

	if ($width < 768) {
		postContentsWidth();
		//postScrollTable();
	}

	$(window).on("resize", function () {
		var $width = $(window).width();
		if ($width < 768) {
			postContentsWidth();
			postScrollTable();
		}
	});

  function copyBtn() {
		var $clickEventType = window.ontouchstart !== null ? "click" : "touchstart";
		const $b = $(".js-copyBtn");

		$b.on($clickEventType, function () {
			const url = $(this).data('url');
			navigator.clipboard.writeText(url);
			$(this).children(".txt").fadeIn(function () {
				$(this).delay(1000).fadeOut("slow");
			});
		});
	}
	copyBtn();
});
